var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "navbar" } }, [
    _c(
      "nav",
      { class: ["sidebar-navigation", { menuCollapsed: _vm.menuCollapsed }] },
      [
        _c("ul", { staticClass: "nav-scroll-list" }, [
          _c("li", { staticClass: "my-3 mx-2 logo-container" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("span", { staticClass: "ml-1 label" }, [
              _vm._v("Dynamic Map Platform"),
            ]),
            _vm._v(" "),
            _vm.versionReleaseInfo
              ? _c("span", { staticClass: "ml-1 label version-label" }, [
                  _vm._v(
                    "MMP - Version " + _vm._s(_vm.versionReleaseInfo.version)
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("li", { attrs: { id: "toolLable" } }, [
            _vm.tool == "DDT"
              ? _c(
                  "div",
                  { staticClass: "tool-label-badge label" },
                  [
                    _c("fa", {
                      staticClass: "tool-label-icon",
                      attrs: { icon: ["fas", "database"] },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "tool-label-text" }, [
                      _vm._v("Data Delivery Tool"),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.tool == "TRT"
              ? _c(
                  "div",
                  { staticClass: "tool-label-badge label" },
                  [
                    _c("fa", {
                      staticClass: "tool-label-icon",
                      attrs: { icon: ["fas", "map"] },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "tool-label-text" }, [
                      _vm._v("Trail Review Tool"),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.globalIsUserAllowed("Data_Delivery_Tool") &&
          _vm.globalIsUserAllowed("Trail_Review_Tool")
            ? _c(
                "li",
                {
                  staticClass: "has-submenu active",
                  class: { open: _vm.groups.home },
                  attrs: {
                    id: "Home",
                    title: _vm.menuCollapsed ? "Home" : null,
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "text_format",
                      on: {
                        click: function ($event) {
                          return _vm.handleGroupOrNav("Home", "home")
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "nav-icon" },
                        [_c("fa", { attrs: { icon: ["fas", "home"] } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-3 label" }, [
                        _vm._v("Home"),
                      ]),
                      _vm._v(" "),
                      _c("fa", {
                        staticClass: "submenu-arrow label",
                        attrs: { icon: ["fas", "angle-right"] },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.toggleGroup("home")
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.globalIsUserAllowed("Data_Delivery_Tool") &&
                  _vm.globalIsUserAllowed("Trail_Review_Tool")
                    ? _c("ul", { staticClass: "submenu mx-4 mt-1" }, [
                        _vm.globalIsUserAllowed("Data_Delivery_Tool")
                          ? _c(
                              "li",
                              {
                                staticClass: "submenu-item ml-3",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleMenu("DDT")
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "submenu-item-icon" },
                                  [
                                    _c("fa", {
                                      attrs: { icon: ["fas", "database"] },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "submenu-item-text" },
                                  [_vm._v("Data Delivery Tool")]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.globalIsUserAllowed("Trail_Review_Tool")
                          ? _c(
                              "li",
                              {
                                staticClass: "submenu-item ml-3",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleMenu("TRT")
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "submenu-item-icon" },
                                  [
                                    _c("fa", {
                                      attrs: { icon: ["fas", "map"] },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "submenu-item-text" },
                                  [_vm._v("Trail Review Tool")]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showMenu
            ? _c(
                "li",
                {
                  attrs: { id: "Reports" },
                  on: {
                    click: function ($event) {
                      return _vm.handleMenu("Reports")
                    },
                  },
                },
                [
                  _c("div", { staticClass: "text_format" }, [
                    _c(
                      "span",
                      { staticClass: "nav-icon" },
                      [_c("fa", { attrs: { icon: ["fas", "table"] } })],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "ml-3 label" }, [
                      _vm._v("Insights"),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.globalIsUserAllowed("MMP")
            ? _c(
                "li",
                {
                  attrs: { id: "MMP", title: _vm.menuCollapsed ? "MMP" : null },
                  on: {
                    click: function ($event) {
                      return _vm.handleMenu("MMP")
                    },
                  },
                },
                [
                  _c("div", { staticClass: "text_format" }, [
                    _c(
                      "span",
                      { staticClass: "nav-icon" },
                      [
                        _c("fa", {
                          attrs: { icon: ["fas", "globe-americas"] },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "ml-3 label" }, [_vm._v("MMP")]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mapsMode
            ? _c(
                "li",
                {
                  staticClass: "logout",
                  attrs: { title: _vm.menuCollapsed ? "Sign Out" : null },
                  on: { click: _vm.signOut },
                },
                [
                  _c("div", { staticClass: "text_format" }, [
                    _c(
                      "span",
                      { staticClass: "nav-icon" },
                      [_c("fa", { attrs: { icon: ["fas", "sign-out-alt"] } })],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "ml-3 label" }, [
                      _vm._v("Sign Out"),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "nav-collapse-list" }, [
          _c(
            "li",
            {
              staticClass: "nav-collapse-toggle",
              attrs: {
                title: _vm.menuCollapsed
                  ? "Expand sidebar"
                  : "Collapse sidebar",
              },
              on: {
                click: function ($event) {
                  return _vm.toggleCollapse()
                },
              },
            },
            [
              _c("div", { staticClass: "nav-toggle-inner" }, [
                _c(
                  "span",
                  {
                    staticClass: "nav-toggle-btn",
                    class: { collapsed: _vm.menuCollapsed },
                  },
                  [
                    _c("fa", {
                      staticClass: "nav-toggle-icon",
                      attrs: { icon: ["fas", "angle-left"] },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", { staticClass: "nav-toggle-text label" }, [
                  _vm._v("Collapse"),
                ]),
              ]),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      { attrs: { href: "https://dmp-maps.com/", target: "_blank" } },
      [
        _c("img", {
          staticClass: "logo",
          attrs: { src: require("../../../assets/dmpLogo.png"), alt: "Banner" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }